import { RefereeListFilter } from './components/referee-list-filter';
import { RefereeListTable } from './components/referee-list-table';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useAuthentication } from '~/hooks/useAuthentication';
import { Button } from '~/components/Button/Button';
import { Fragment } from 'react/jsx-runtime';
import { Link } from 'react-router';

export function Page() {
  const { can } = useAuthentication();

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Domarregister" />

        {can('create-referee') && (
          <Link to="create">
            <Button type="button">Skapa ny</Button>
          </Link>
        )}
      </PageLayout.Header>

      <PageLayout.Section>
        <RefereeListFilter />
        <RefereeListTable />
      </PageLayout.Section>
    </Fragment>
  );
}
